export const POLYLINE_BUTTON_TITLE = 'Teken een lijn om de afstand te meten'
export const POLYGON_BUTTON_TITLE = 'Teken een vlak om data te selecteren'
export const REMOVE_BUTTON_TITLE = 'Verwijder geselecteerde tekening'
